$(window).on('load resize', function () {
    $(".js-image-src").each(function() {
        //If we are not on mobile
        if($(window).width() > 768) {
            $(this).attr('src', $(this).data('src-desktop'));
        } else {
            $(this).attr('src', $(this).data('src-mobile'));
        }
    })
});